import { Button, Checkbox, Modal, Radio, Row, Col, Icon } from 'antd';
import React, { Component } from 'react';
import lang from './../../../../languages/en';
import { alertWarning } from './../../../../services/dialog';
import store from './../../../../store';
import Rows from './Rows';
import './styles.css';
import { isArray } from 'util';

const RadioGroup = Radio.Group;

class TranslationItemName extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listItems: [],
            listItemMapping: [],
            confirmItemName: [],
            checkedItemName: [],
            checkedAll: true,
            showAlertProhibited: false,
            changeItemOrder: 1,
        }
    }

    componentDidMount() {
        // let { changeItemOrder } = this.state;
        // this.props.onChange({ value: changeItemOrder, column: 'mappingOrderSameSku' })
    }
    loadData = () => {
        let data = store.getState()
        let listItems = []
        let confirmItemName = []
        const { pageType } = this.props
        let showAlertProhibited = false;
        let SKUDuplicateOrderOther = false
        listItems = pageType === 'editOrder' ? data.editOrder.items : data.addOrder.items;
        listItems.map((e, i) => {
            this.props.listItemMapping.map((ep, ip) => {
                if (e.sku === ep.SKU && (ep.Status === 0)) {
                    e.type = 'NEW'
                    e.checkedMap = true
                    confirmItemName.push(e)
                }
                if (e.sku === ep.SKU && (ep.Status === 1)) {
                    e.type = 'UPD'
                    e.checkedMap = true
                    e.item_code_mapping = ep.ItemCode
                    e.item_name_mapping = ep.ItemnameUS
                    e.origin_mapping = ep.Origin
                    e.LastUpdateDT = ep.LastUpdateDT
                    e.SKUDuplicateOrderOther = ep.SKUDuplicateOrderOther,
                        e.HasApproveKeyWordBLMapping = ep.HasApproveKeyWordBL,
                        e.ProhibitedKeyWordMapping = ep.ProhibitedKeyWord,
                        confirmItemName.push(e)
                }
                if (e.checkedMap && ep.SKUDuplicateOrderOther) {
                    SKUDuplicateOrderOther = true
                }
                if (isArray(e.ProhibitedKeyWord) && e.ProhibitedKeyWord.length > 0) {
                    showAlertProhibited = true;
                }
                return false;
            })
            return false;
        })

        this.setState({
            listItems,
            listItemMapping: this.props.listItemMapping,
            confirmItemName,
            checkedAll: true,
            showAlertProhibited
        }, () => {
            this.props.onChange({ value: false, column: 'isLoading' })
        })
        this.props.onChange({ value: true, column: 'buttonAddOrUpdateMapping' })
        this.props.onChange({ value: SKUDuplicateOrderOther, column: 'SKUDuplicateOrderOther' })
    }

    getValue = () => {
        return this.state.confirmItemName
    }

    checked = (value, sku) => {
        let { confirmItemName } = this.state,
            checkedAll = false,
            checkedData = [],
            SKUDuplicateOrderOther = false

        confirmItemName.map((em, im) => {
            if (sku === em.sku) {
                em.checkedMap = value
            }
            if (em.checkedMap) {
                checkedData.push(im)
            }
            if (em.checkedMap && em.SKUDuplicateOrderOther) {
                SKUDuplicateOrderOther = true
            }
            return em
        })
        if (checkedData.length === confirmItemName.length) {
            checkedAll = true
        }
        let checkButton = !checkedData.length ? false : true
        this.props.onChange({ value: checkButton, column: 'buttonAddOrUpdateMapping' })
        this.props.onChange({ value: SKUDuplicateOrderOther, column: 'SKUDuplicateOrderOther' })
        this.setState({
            confirmItemName,
            checkedAll
        })
    }

    onCheckedAll = (value) => {
        const { confirmItemName } = this.state
        let checkedAll = value
        confirmItemName.map((ec, ic) => {
            ec.checkedMap = value
            return ec;
        })
        let disabledButton = !value ? false : true
        this.props.onChange({ value: disabledButton, column: 'buttonAddOrUpdateMapping' })

        this.setState({
            confirmItemName,
            checkedAll
        })
    }

    onChangeTypeMapping = (value) => {
        // this.props.onChange({ value: value, column: 'mappingOrderSameSku' })
        this.setState({
            changeItemOrder: value
        })
    }

    handleConfirmTypeMapping = () => {
        this.asyncMappingOrderSameSku();
    }

    async asyncMappingOrderSameSku() {
        let { changeItemOrder } = this.state;
        await this.props.onChange({ value: changeItemOrder, column: 'mappingOrderSameSku' })
        await this.props.confirmTypeMapping();
    }


    onCancelTypeMapping = (e) => {
        if (e.keyCode === 27) {
            this.props.onChange({ value: false, column: 'modalMappingItem' })
        }
        this.props.onChange({ value: false, column: 'modalTypeMappingItem' })
    }

    confirmMapping = () => {
        const { confirmItemName } = this.state
        let setArray = []
        confirmItemName && confirmItemName.map((e, i) => {
            if (e.checkedMap) {
                setArray.push(i)
            }
            return false
        })
        let type = !setArray.length ? 'notMappingOrderOther' : null
        this.props.confirmMapping(type)
    }

    onCancel = () => {
        alertWarning('Item Master Update cancelled.',
            'Changes to your order have not been saved.',
            () => this.props.onChange({ value: false, column: 'modalMappingItem' })
        )
    }

    render() {
        return (
            <div>
                <Modal
                    title="ITEM MASTER UPDATE"
                    visible={this.props.order.modalMappingItem}
                    onCancel={() => this.onCancel()}
                    className='confirm-item-name-mapping'
                    maskClosable={false}
                    centered
                    footer={[
                        <Button
                            key="onCancel"
                            className="cancel"
                            onClick={() => this.onCancel()}>Cancel</Button>,
                        <Button
                            key="submit"
                            type="primary"
                            onClick={this.confirmMapping}>{this.props.order.buttonAddOrUpdateMapping ? 'Add / Update' : 'OK'}
                        </Button>,
                    ]}
                >
                    <div id='translation-item-name'>
                        <div>
                            <p>{lang.confirm_item_name_mapping_line1}</p>
                            <p>{lang.confirm_item_name_mapping_line2}</p>
                        </div>

                        <div className="alert-contains-prohibited" style={{ "display": this.state.showAlertProhibited ? "block" : "none" }}>
                            <div className="al-icon">
                                <span className="box-rectangle">
                                    <Icon type="exclamation"></Icon>
                                </span>
                            </div>
                            <div className="al-content">
                                <span>{lang.alert_contains_prohibited}</span>
                            </div>
                        </div>

                        <table>
                            <tbody>
                                <tr>
                                    <th style={{ width: '37px' }}>
                                        <Checkbox
                                            onChange={(e) => this.onCheckedAll(e.target.checked)}
                                            checked={this.state.checkedAll}
                                        />
                                    </th>
                                    <th style={{ width: '40px' }}>NO</th>
                                    <th style={{ width: '100px' }}></th>
                                    <th style={{ width: '100px' }}>SKU</th>
                                    <th style={{ width: '100px' }}>CHANNEL ITEM CODE</th>
                                    <th style={{ width: '200px' }}>ITEM NAME(EN)</th>
                                    <th style={{ width: '40px' }}></th>
                                    <th style={{ width: '64px' }}>ORIGIN</th>
                                </tr>
                            </tbody>
                        </table>
                        <div className='scoll-translation-item-name'>
                            <table>
                                <tbody>
                                    <Rows
                                        confirmItemName={this.state.confirmItemName}
                                        checked={this.checked}
                                    />
                                </tbody>
                            </table>
                        </div>

                    </div>
                </Modal>
                <Modal
                    title="Do you want apply item information changes to other orders?"
                    visible={this.props.order.modalTypeMappingItem}
                    onCancel={(e) => this.onCancelTypeMapping(e)}
                    className='confirm-type-update-order'
                    maskClosable={false}
                    centered
                    footer={[
                        <Button
                            key="submit"
                            type="primary"
                            onClick={this.handleConfirmTypeMapping}>OK
                        </Button>,
                    ]}
                >
                    <div>
                        <RadioGroup
                            onChange={(e) => this.onChangeTypeMapping(e.target.value)}
                            defaultValue={this.state.changeItemOrder}
                        >
                            <Radio value={1}>Update only "Awaiting Finalization" records</Radio>
                            <Radio value={2}>Update "Awaiting Finalization" and "Awaiting Shipments" records</Radio>
                            <Radio value={3}>No update. Update only this order</Radio>
                        </RadioGroup>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default TranslationItemName;


// WEBPACK FOOTER //
// ./src/containers/orders/components/translation-item-name/index.js